import { notNull } from "@msys/common";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { isArray } from "lodash-es";
import React from "react";
import { useApplyOverrides } from "../../../../commons/hooks/useApplyOverrides.js";

export const QuoteTemplateToggleApplyOverridesButton = () => {
  const [applyOverrides, setApplyOverrides] = useApplyOverrides();
  const { t } = useTranslate(["QuoteItem", "Global"]);
  const value = [applyOverrides ? "apply" : null].filter(notNull);
  return (
    <ToggleButtonGroup
      size="extra-small"
      value={value}
      onChange={(e, value) => {
        setApplyOverrides(isArray(value) && value.includes("apply"));
      }}
    >
      <ToggleButton value="apply">
        <Tooltip
          title={
            applyOverrides
              ? t("Overrides applied", { ns: "QuoteItem" })
              : t("Overrides not applied", { ns: "QuoteItem" })
          }
        >
          <PublishedWithChangesIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
